import { useQuery } from '@tanstack/react-query'
import { useAccount } from './useAccount'
import { get } from '../api'
import { BaseURLS } from '../api/axios'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { selectIsRefreshBackpackValues } from '../store/rushbSelectors'
import { setBackpackValues, setIsRefreshBackpackValues } from '../store/rushbSlice'

export interface GemSkinsValueResponse {
  totalValue: number
  totalGemSkins: number
}

export interface UseGemSkinsValueParams {
  enabled?: boolean
}

const useGemSkinsValue = ({ enabled = true }: UseGemSkinsValueParams = {}) => {
  const { isLogin } = useAccount()
  const isRefreshBackpackValues = useSelector(selectIsRefreshBackpackValues)
  const dispatch = useDispatch()

  const { data, error, refetch, isFetching } = useQuery<GemSkinsValueResponse>({
    queryKey: ['gem-skins-value', isLogin],
    queryFn: async () => {
      const response: GemSkinsValueResponse = await get(
        '/v1/skins/value',
        {},
        { baseURL: BaseURLS.rush },
        isLogin,
      )
      dispatch(setBackpackValues(response.totalValue))
      return response
    },
    enabled: isLogin && enabled,
  })

  useEffect(() => {
    if (isRefreshBackpackValues) {
      refetch()
      dispatch(setIsRefreshBackpackValues(false))
    }
  }, [dispatch, isRefreshBackpackValues, refetch])

  return {
    data,
    totalValue: data?.totalValue || 0,
    totalGemSkins: data?.totalGemSkins || 0,
    isFetching,
    error,
    refetch,
  }
}

export default useGemSkinsValue
